import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { MantenimientoScreanPage } from './mantenimiento-screan.page'
import { ModuleSharedModule } from '../../modules/module-shared.module'


@NgModule({
  exports: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule
  ],
  declarations: [
    MantenimientoScreanPage
  ]
})

export class MantenimientoScreanPageModule {}
